import { useContext, useEffect } from "react";
import RelifeContact from "./homeLayout/RelifeContact";
import RelifeContactNew from "./homeLayout/RelifeContactNew";
import RelifeFooter from "./homeLayout/RelifeFooter";

import "./style/About.css";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "./auth/AuthProvider";

export default function About() {
  const { user, googleUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // localStorage.setItem("postLoginRedirectTheme", prevLocation);

    if (!user && !googleUser) {
      // localStorage.setItem("postLoginRedirectTheme", prevLocation);
      localStorage.setItem("postLoginRedirect", location.pathname);
      // return;
    }
  }, [user, googleUser, navigate]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("hero-text1");
          observer.unobserve(entry.target);
        }
      });
    });

    document.querySelectorAll("#parentAbout").forEach((element) => {
      observer.observe(element);
    });
  }, []);

  return (
    <>
      <section className="aboutPage">
        <div className="aboutCard">
          <h1>About Introspecta</h1>

          <p>
            Introspecta is a premium space for guided self-reflection. We
            believe that in a world of constant noise, the most important
            conversation you can have is the one with yourself.
          </p>

          <p>
            Our approach is rooted in calm, structured introspection. We don’t
            provide therapy; we provide the architecture for you to explore your
            own thoughts through curated audio journeys.
          </p>

          <blockquote>
            “To know oneself is the beginning of all wisdom.”
          </blockquote>

          <p>
            Every theme in Introspecta is designed to be a professional, calm,
            and safe environment for your personal growth. There is no pressure,
            no diagnosis, and no judgment — only space to reflect.
          </p>
        </div>
      </section>

      <RelifeContactNew />
    </>
  );
}
